module.exports = __webpack_public_path__ + "img/periferico-180.d782bc91.png";